import { createContext, memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StepStart from 'components/steps/step-start/StepStart';
import Step1 from 'components/steps/step-1/Step1';
import Step2 from './steps/step-2/Step2';
import Step3 from './steps/step-3/Step3';
import Step4 from './steps/step-4/Step4';
import StepFeedback from './steps/step-feedback/StepFeedback';
import Step5 from './steps/step-5/Step5';
import Step6 from './steps/step-6/Step6';
import Step7 from './steps/step-7/Step7';
import Step8 from './steps/step-8/Step8';
import Step6A from './steps/step-6/Step6A';
import Step6B from './steps/step-6/Step6B';
import Step6C from './steps/step-6/Step6C';
import StepThanks from './steps/step-thanks/StepThanks';
import { useSearchParams } from 'react-router-dom';
import { fillDataWithQuery } from 'store/slices/form.slice';
import Step1WithQuery from './steps/step-1/Step1WithQuery';

export const UserFormContext = createContext();

const UserForm = () => {
  const { step } = useSelector((state) => state.global);
  const [insFront, setInsFront] = useState(null);
  const [insBack, setInsBack] = useState(null);
  const [labOrders, setLabOrders] = useState(null);
  const [dateData, setDateData] = useState({
    date1: null,
    date2: null,
    date3: null,
  });
  const [validQueryMode, setValidQueryMode] = useState(false);
  const [shortForm, setShortForm] = useState(false);
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = Object.fromEntries([...searchParams]);
    if (
      params.first_name &&
      params.last_name &&
      params.mobile_number &&
      params.email
    ) {
      const pattern = /^([a-zA-Z0-9_.-]+@[\da-z.-]+\.[a-z.]{2,6})$/;
      if (pattern.test(params.email)) {
        setValidQueryMode(true);
      } else {
        setValidQueryMode(false);
      }
    } else {
      setValidQueryMode(false);
    }

    dispatch(fillDataWithQuery(params));
  }, [searchParams, dispatch]);

  return (
    <UserFormContext.Provider
      value={{
        insFront,
        insBack,
        labOrders,
        setInsFront,
        setInsBack,
        setLabOrders,
        dateData,
        setDateData,
        shortForm,
        setShortForm,
      }}
    >
      {step === 0 && <StepStart />}
      {step === 1 ? !validQueryMode ? <Step1 /> : <Step1WithQuery /> : null}
      {step === 2 ? !shortForm ? <Step2 /> : <Step4 /> : null}
      {step === 3 ? !shortForm ? <Step3 /> : <Step5 /> : null}
      {step === 4 ? !shortForm ? <Step4 /> : <Step6 /> : null}
      {step === 20 && <StepFeedback />}
      {step === 5 ? !shortForm ? <Step5 /> : <Step7 /> : null}
      {step === 6 ? !shortForm ? <Step6 /> : <Step8 /> : null}
      {step === 61 && <Step6A />}
      {step === 62 && <Step6B />}
      {step === 63 && <Step6C />}
      {step === 7 ? !shortForm ? <Step7 /> : <StepThanks /> : null}
      {step === 8 && <Step8 />}
      {step === 9 && <StepThanks />}
    </UserFormContext.Provider>
  );
};

export default memo(UserForm);
